/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Quick_AnswerInputs */

const en_control_quick_answer = /** @type {(inputs: Control_Quick_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quick answer`)
};

const zh_control_quick_answer = /** @type {(inputs: Control_Quick_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快速答案`)
};

/**
* | output |
* | --- |
* | "Quick answer" |
*
* @param {Control_Quick_AnswerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_quick_answer = /** @type {((inputs?: Control_Quick_AnswerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Quick_AnswerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_quick_answer(inputs)
	return zh_control_quick_answer(inputs)
});
export { control_quick_answer as "control.quick_answer" }